import styled from 'styled-components'

export const MainContainer = styled.div`
  background-color: ${({lightTheme}) => lightTheme ? '#ffffff' : '#26222a'};
  display: block;
  width: 100%;
  min-height: 100%;
`
